import Vue from 'vue';
import VueRouter from 'vue-router';
import BootstrapVue, {BootstrapVueIcons} from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './theme.scss';
import Main from './components/Main';
import App from './components/App';

import axios from 'axios';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

import Login from './pages/Login';

import {server} from './variables';
import Statistic from "@/pages/Statistic";
import Notifications from "@/pages/Notifications";
import Prices from "@/pages/Prices";
import Users from "@/pages/Clients";
import Managers from "@/pages/Managers";
import Options from "@/pages/Options";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)
Vue.use(VueRouter);

const routes = [
    { path: '/', component: Login },
    {
        path: '/home', component: Main, children: [
            { path: 'users', component: Users, meta: { requiresAuth: true } },
            { path: 'managers', component: Managers, meta: { requiresAuth: true } },
            { path: 'notifications', component: Notifications, meta: { requiresAuth: true } },
            { path: 'prices', component: Prices, meta: { requiresAuth: true } },
            { path: 'stat', component: Statistic, meta: { requiresAuth: true } },
            { path: 'options', component: Options, meta: { requiresAuth: true } },
        ]
    },
    {
        path: '/login', component: Login, meta: {}
    }
];

const router = new VueRouter({ routes });

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const token = localStorage.getItem('token');
        axios.get(`${server}/online`,  { headers: {
                'admin-token': token,
            } })
            .then(() => {
                next();
            })
            .catch(() => {
                next({
                    path: '/login',
                });
            })
    } else {
        next();
    }
});


new Vue({
    render: h => h(App),
    router
}).$mount('#app');
